import { useState, useMemo } from 'react';
import { styled } from '@mui/material/styles';
import { Select } from '@components/Select';
import { ModalBase } from '@components/Modal';
import { useWhatsAppBusinessTemplates } from '@hooks';
import { handleApiError } from '@helpers/api';
import { inboxService } from '@services';
import { useTranslation } from '@hooks';

const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        width: 500,
        '@media (max-width: 600px)': {
            width: 'calc(100% - 32px)',
        },
    },
    '& .modal-base-content': {
        padding: 16,
    },
});

const SendWhatsAppTemplate = ({ isOpen, onClose, channelId, conversationId }) => {
    const [template, setTemplate] = useState('');
    const [isSendingMessage, setIsSendingMessage] = useState(false);

    const { t } = useTranslation();
    const { getWhatsAppBusinessTemplatesOptionsByChannel } = useWhatsAppBusinessTemplates();

    const whatsappTemplatesOptions = useMemo(() => {
        return getWhatsAppBusinessTemplatesOptionsByChannel(channelId, { hasButtons: false });
    }, [channelId]);

    const onSendTemplate = async () => {
        try {
            setIsSendingMessage(true);
            await inboxService.sendWhatsAppTemplate(conversationId, template);
            setTemplate('');
            onClose();
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsSendingMessage(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            handleClose={onClose}
            title={t('common.newMessage')}
            onPrimaryAction={onSendTemplate}
            primaryActionText={t('buttons.sendMessage')}
            primaryActionDisabled={!template || isSendingMessage}
            onSecondaryAction={onClose}
            secondaryActionText={t('buttons.cancel')}
        >
            <Select
                value={template}
                name="template"
                onChange={e => setTemplate(e.target.value)}
                label={t('FeedbackOverview.template')}
                fullWidth
                options={whatsappTemplatesOptions}
            />
        </Modal>
    );
};

export default SendWhatsAppTemplate;
